<template>
    <div class="error-msg-wrap">
        <div v-if="loaded" class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h3>Name</h3>
            <input type="text" v-model="formData.Name" />
            <h3>Columns</h3>
            <draggable :list="formData.ColumnsJSON">
                <div v-for="(col, i) in formData.ColumnsJSON" :key="i" class="link-item">
                    <div class="form-close">
                        <svg @click="removeCol(i)" style="color:red;width:18px;height:18px;" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z"/></svg>
                    </div>
                    <input style="margin:0 0 5px" type="text" v-model="col.name" placeholder="Column Name" />
                </div>
            </draggable>
            <div style="display:flex;margin-top:10px">
                <div @click="addCol()" class="btn" style="margin:0">Add Column</div>
            </div>
            <input style="margin-top:25px" :class="disableButton ? 'disable-button' : ''" type="submit" value="Submit" @click="submit()" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import { VueDraggableNext } from 'vue-draggable-next';

export default defineComponent({
    name: 'AddEditSkillsMatrix',
    props: [ 'matrixToEdit' ],
    components: {
        draggable: VueDraggableNext
    },
    data() {
        return {
            disableButton: false,
            loaded: false,
            formData: {
                Name: '',
                ColumnsJSON: [] as any
            },
        }
    },
    async created() {
        if(this.matrixToEdit) {
            this.formData = JSON.parse(JSON.stringify(this.matrixToEdit));
        }

        this.loaded = true;
    },
    methods: {
        async submit() {
            if(!this.formData.Name) {
                alert('Include a name');
                return;
            }
            if(!this.formData.ColumnsJSON.length) {
                alert('Include columns');
                return;
            }
            this.disableButton = true;

            await axios.post(`${this.$store.state.apiUrl}/api/skillsmatrices`, this.formData)
                .then(resp => {
                    this.$emit('close');
                })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })

            this.disableButton = false;
        },
        addCol() {
            this.formData.ColumnsJSON.push({
                name: '',
                id: new Date().getTime().toString(36)
            })
        },
        removeCol(i: number) {
            this.formData.ColumnsJSON.splice(i, 1);
        }
    }
});
</script>
